import { Panel, PanelHeader, PanelInset, PanelTitle, TableTd, TableTr } from '@customerio/pluma-components/react';
import { useActivityLogEnvironment } from '@/services/db/activity-log/queries';
import { activityLogTypeLabel, NameCell, TimestampCell, TypeCell } from '@/features/activity-feed';
import { ActivityLogTable, useObjectActivityLogs, type ActivityLogTableColumn } from './activity-log-table';
import { useObjectDetail } from './context';

const RECENT_ACTIVITY_LIMIT = 5;

const COLUMNS: readonly ActivityLogTableColumn[] = [
  { label: 'Activity type' },
  { label: 'Activity name' },
  { label: 'Timestamp', textAlign: 'right' },
];

const TYPE_TERMS = {
  campaignSingular: 'Automation',
  personSingular: 'Person',
  personPlural: 'People',
};

export function ObjectRecentActivity() {
  const { record, workspaceId } = useObjectDetail();
  const { identifiers } = useActivityLogEnvironment(String(workspaceId));
  const { query, rows } = useObjectActivityLogs(workspaceId, record.identifiers.cio_object_id, {
    limit: RECENT_ACTIVITY_LIMIT,
  });

  return (
    <Panel>
      <PanelHeader pb="0" aria-labelledby="recent-activity-header">
        <PanelTitle id="recent-activity-header" size="md">
          Recent Activity
        </PanelTitle>
      </PanelHeader>
      <PanelInset pb="0">
        <ActivityLogTable
          caption="Recent Activity Table"
          columns={COLUMNS}
          query={query}
          errorMessage="Could not load recent attribute changes."
          rows={rows}
          renderRow={(row) => (
            <TableTr key={row.log.id}>
              <TableTd>
                <TypeCell
                  row={row}
                  label={activityLogTypeLabel(row.log, TYPE_TERMS)}
                  workspaceId={String(workspaceId)}
                  personSingular={TYPE_TERMS.personSingular}
                />
              </TableTd>
              <TableTd>
                <NameCell row={row} workspaceId={String(workspaceId)} identifiers={identifiers} />
              </TableTd>
              <TableTd textAlign="right">
                <TimestampCell value={row.log.timestamp} />
              </TableTd>
            </TableTr>
          )}
        />
      </PanelInset>
    </Panel>
  );
}
